export const MP_TERMINAL_PREAPPROVAL_STATUSES = new Set(["cancelled", "finished", "expired"]);

export interface PendingAuthorizationInput {
  status: string;
  mp_verified_status?: string | null;
  last_charge_status?: string | null;
}

export type DeadPendingReason = "first_payment_rejected" | "closed_by_mercadopago";

export function deadPendingReason(preapproval: PendingAuthorizationInput | null | undefined): DeadPendingReason | null {
  if (!preapproval || preapproval.status !== "pending") return null;
  if (preapproval.last_charge_status === "rejected") return "first_payment_rejected";
  if (preapproval.mp_verified_status && MP_TERMINAL_PREAPPROVAL_STATUSES.has(preapproval.mp_verified_status)) {
    return "closed_by_mercadopago";
  }
  return null;
}

export const DEAD_PENDING_TITLE = "Esta autorización ya no está disponible";

export function deadPendingExplanation(reason: DeadPendingReason): string {
  return reason === "first_payment_rejected"
    ? "MercadoPago rechazó el primer cobro y cerró esta autorización, así que el enlace ya no funciona. No se hizo ningún cobro."
    : "MercadoPago cerró esta autorización antes de que se completara, así que el enlace ya no funciona. No se hizo ningún cobro.";
}

export const DEAD_PENDING_RETRY_HINT = "Vuelve a intentarlo con la misma tarjeta o con otra.";

export const DEAD_PENDING_RETRY_FAILED = "No pudimos crear una nueva autorización. Intenta de nuevo en unos minutos.";
